// Barrel export for UI components
export { default as SeoHead, generateMetadata } from "./SeoHead";
export { default as Card } from "./Card";
export { default as EmptyState } from "./Common/EmptyState";

// Type exports
export type { EmptyStateProps } from "./Common/EmptyState/types";
